<div class="container content-box module-content">
    <h2>Activity</h2>
    <i>Each of the following flashcards contain statements that are NOT very effective for postive communication. Think about rephrasing these statements into an "I" message that conveys a more positive message. Then, click each card to see a correctly reworded example.</i>
    <div class="flip-cards">
        <div class="flip-card" (click)="flipped.card[0] = !flipped.card[0]; flipped.all = all(flipped.card, true)" [class.flipped]="flipped.card[0]">
            <div class="flip-card-inner">
                <div class="flip-card-front">
                    <h5>You are always so loud. I don't understand how you can be so inconsiderate!</h5>
                </div>
                <div class="flip-card-back">
                    <h5>I want you to quiet down. It is keeping me up at night.</h5>
                </div>
            </div>
        </div>
        <div class="flip-card" (click)="flipped.card[1] = !flipped.card[1]; flipped.all = all(flipped.card, true)" [class.flipped]="flipped.card[1]">
            <div class="flip-card-inner">
                <div class="flip-card-front">
                    <h5>What do you mean I can't have people over? You can't tell me who can and cannot stay with me!</h5>
                </div>
                <div class="flip-card-back">
                    <h5>I am able to have anyone I want over. I will make sure to not disrupt you in the future.</h5>
                </div>
            </div>
        </div>
        <div class="flip-card" (click)="flipped.card[2] = !flipped.card[2]; flipped.all = all(flipped.card, true)" [class.flipped]="flipped.card[2]">
            <div class="flip-card-inner">
                <div class="flip-card-front">
                    <h5>Clean up the kitchen!</h5>
                </div>
                <div class="flip-card-back">
                    <h5>I would appreciate it if you can clean up the kitchen. I am struggling to cook in there currently.</h5>
                </div>
            </div>
        </div>
        <div class="flip-card" (click)="flipped.card[3] = !flipped.card[3]; flipped.all = all(flipped.card, true)" [class.flipped]="flipped.card[3]">
            <div class="flip-card-inner">
                <div class="flip-card-front">
                    <h5>Move your car or I am getting it towed!</h5>
                </div>
                <div class="flip-card-back">
                    <h5>I want you to move your car. It is blocking me in.</h5>
                </div>
            </div>
        </div>
        <div class="flip-card" (click)="flipped.card[4] = !flipped.card[4]; flipped.all = all(flipped.card, true)" [class.flipped]="flipped.card[4]">
            <div class="flip-card-inner">
                <div class="flip-card-front">
                    <h5>Do you think you are the only one living here? You need to think about other people's safety and quit leaving the door open!</h5>
                </div>
                <div class="flip-card-back">
                    <h5>I would appreciate it if you would close the door after you open it. It is not safe for me when it is left open.</h5>
                </div>
            </div>
        </div>
        <div class="flip-card" (click)="flipped.card[5] = !flipped.card[5]; flipped.all = all(flipped.card, true)" [class.flipped]="flipped.card[5]">
            <div class="flip-card-inner">
                <div class="flip-card-front">
                    <h5>Your stupid kids are always playing in the hall and being noisy. You need to put a stop to it now!</h5>
                </div>
                <div class="flip-card-back">
                    <h5>I would like you to tell your kids to quiet down when they play in the hall.</h5>
                </div>
            </div>
        </div>
        <div class="flip-card" (click)="flipped.card[6] = !flipped.card[6]; flipped.all = all(flipped.card, true)" [class.flipped]="flipped.card[6]">
            <div class="flip-card-inner">
                <div class="flip-card-front">
                    <h5>You better get up here and fix my sink!</h5>
                </div>
                <div class="flip-card-back">
                    <h5>I would be very happy if you fixed my sink.</h5>
                </div>
            </div>
        </div>
        <div class="flip-card" (click)="flipped.card[7] = !flipped.card[7]; flipped.all = all(flipped.card, true)" [class.flipped]="flipped.card[7]">
            <div class="flip-card-inner">
                <div class="flip-card-front">
                    <h5>The carpet in the hall is always filthy. You should clean it!</h5>
                </div>
                <div class="flip-card-back">
                    <h5>I would appreciate it if you cleaned the carpet in the hall.</h5>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container navigate-buttons">
    <button type="button" class="btn waves-dark w-25" (click)="goBack($event)"><i class="fas fa-angle-left mr-3"></i>{{backTitle}}</button>
    <button type="button" class="btn waves-dark w-25" (click)="(previewByAdmin || flipped.all || !delay) && goNext($event)" [ngClass]="previewByAdmin || flipped.all || !delay ? '' : 'disabled hoverable'" [matTooltip]="flipped.all || !delay ? '' : 'To proceed, click each card to see a correctly reworded example.'">{{nextTitle}}<i class="fas fa-angle-right ml-3"></i></button>
</div>
